(function(angular){
	'use strict';
	
	angular
		.module('coreModule', [
			'alertModule',
			'angular.filter',
			'BaseConfig',
			'bigModule',
			'eventsModule',
			'highChartsModule',
			'iconModule',
			'imageLazyModule',
			'modalModule',
			'ngTouch',
			'ngRaven',
			'navModule',
			'placeholderModule',
			'toastModule',
			'popoverModule',
			'SharedFilters',
			'smoothScroll',
			'urlModule'
		])
		.config(['$qProvider', function ($qProvider) {
			$qProvider.errorOnUnhandledRejections(false);
		}])
		.run([
				'$rootScope', 
				'ModalFactory', 
				'ToastFactory', 
				function($rootScope, ModalFactory, ToastFactory){
					$rootScope.ToastFactory = ToastFactory;
					$rootScope.ModalFactory = ModalFactory;
					$rootScope.openModals = ModalFactory.openModals;
					ToastFactory.init();
				}
			]);

})(window.angular);